/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */

import { translations } from 'locales/translations';
import { _t } from 'shared/utils/messages';

export const messages = {
  categoriesTitle: () =>
    _t(translations.main.categories.categoriesTitle, 'Ngành hàng'),
  itemDetailsTitle: () =>
    _t(translations.main.itemDetails.itemDetailsTitle, 'Chi tiết sản phẩm'),
  store: () => _t(translations.main.itemDetails.store, 'Cửa hàng'),
  supplier: () => _t(translations.main.itemDetails.supplier, 'Nhà phân phối'),
  searchTitle: () => _t(translations.main.search.searchTitle, 'Bạn cần tìm gì'),
  locationTitle: () =>
    _t(translations.main.location.locationTitle, 'Địa chỉ nhận hàng'),
  cartTitle: () => _t(translations.main.cart.cartTitle, 'Giỏ hàng của tôi'),
  promoTitle: () => _t(translations.main.cart.promoTitle, 'Mã khuyến mãi'),
  enterPromoCode: () =>
    _t(translations.main.cart.enterPromoCode, 'Nhập mã khuyến mãi'),
  recipientInformation: () =>
    _t(translations.main.cart.recipientInformation, 'Thông tin người nhận'),
  eInvoiceTitle: () =>
    _t(translations.main.cart.eInvoiceTitle, 'Hoá đơn điện tử'),
  enterDeliveryAddress: () =>
    _t(
      translations.main.location.enterDeliveryAddress,
      'Nhập địa chỉ nhận hàng'
    ),
  gpsOff: () =>
    _t(
      translations.main.location.gpsOff,
      'Không thể xác định vị trí của bạn. Vui lòng chấp nhận quyền truy cập trên trình duyệt'
    ),
  totalItems: () => _t(translations.main.totalItems, 'Tất cả sản phẩm'),
};
